// removed by extract-text-webpack-plugin
module.exports = {"root":"IconEmailSuccess__root__2XBHv","marketplaceStroke":"IconEmailSuccess__marketplaceStroke__1UmkD","successFill":"IconEmailSuccess__successFill__229n8","checkStroke":"IconEmailSuccess__checkStroke__1jDtU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconEmailSuccess/IconEmailSuccess.css
// module id = 1839
// module chunks = 0